import {useAppDispatch, useAppSelector} from "../redux/stateHooks";
import {QueryMediaVariablesType} from "../definitions/types";
import {updateReviewMediaVariables} from "../redux/slices/reviewMediaPagination";

export const useReviewMediaVariables = () => {
    const dispatch = useAppDispatch();
    const variables = useAppSelector((state) => state.reviewMediaPagination.value);

    return {
        variables,
        mutations: {
            update: (variables: Partial<QueryMediaVariablesType>) => dispatch(updateReviewMediaVariables(variables))
        }
    }
}